import React from "react";
import { Link } from "react-scroll";
import { scrollDuration } from "../../../config/commonConfig";
import videobg from "../../../videos/home.mp4";
import {
  HeroBottomTitle,
  HeroCta,
  HeroTagline,
  ProfileImage,
} from "../../shared/IntroHeroContent";

const BottomHeaderVideoBgIntro = () => {
  return (
    <section id="home">
      <div className="hero-wrap">
        <div className="hero-mask opacity-8 bg-primary" />
        <div className="player hero-bg">
          <video
            src={videobg}
            autoPlay
            muted
            loop
            style={{
              width: "100%",
              height: "100vh",
              minHeight: "100%",
              objectFit: "cover",
            }}
          ></video>
        </div>
        <div className="hero-content d-flex flex-column fullscreen py-5">
          <div className="container my-auto">
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <ProfileImage wrapperClassName="bg-white shadow rounded-pill p-2 mb-4 d-inline-block wow fadeInUp" />
                <HeroBottomTitle className="text-10 text-uppercase fw-600 mb-4 wow fadeInUp" />
                <HeroTagline className="text-5 pb-3 wow fadeInUp" />
                <HeroCta className="btn btn-dark rounded-0 smooth-scroll wow fadeInUp" />
              </div>
            </div>
          </div>
          <div className="container py-2 text-center">
            <Link
              className="scroll-down-arrow text-dark smooth-scroll"
              smooth="easeInOutQuint"
              duration={scrollDuration}
              style={{ cursor: "pointer" }}
              to="about"
            >
              <span className="animated">
                <i className="fas fa-arrow-down" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BottomHeaderVideoBgIntro;
